<!-- HEADER -->
<div class="dialog-header">
  <h3 class="text-black text-lg font-semibold">{{ title }}</h3>
  <button mat-icon-button aria-label="Close" (click)="lFN_OnButtonClick(false);">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- CONTENT -->
<div mat-dialog-content class="dialog-content">
  {{ message }}
</div>

<!-- ACTIONS -->
<div mat-dialog-actions class="dialog-actions">
  <ng-container *ngFor="let btn of buttons">
    <!-- <button
      mat-raised-button
      [color]="btn.color || 'primary'"
      (click)="lFN_OnButtonClick(btn.value);"
    >
      {{ btn.label }}
    </button> -->

    <button (click)="lFN_OnButtonClick(btn.value);" class="px-6 py-2 rounded-md
        bg-gradient-to-r from-slate-900 to-black
        text-white text-[12px] font-medium tracking-widest uppercase
        shadow hover:from-black hover:to-slate-800
        transition-all duration-150 whitespace-nowrap">
      {{ btn.label }}
    </button>

  </ng-container>
</div>

